import React, { useState } from 'react';
import './BulkSMSPage.css';
import './ContentBilling.css';


const features = [
  { title: 'Easy-To-Use Platform', subtitle: '(no tech degree needed)' },
  { title: 'Real-Time Delivery Reports' },
  { title: 'Contact List Management' },
  { title: 'Schedule SMS & Create Personalized Messages' },
  { title: 'API Access for Developers' },
  { title: 'Two-way Messaging', subtitle: '(yes, they can reply!)' },
];

const billingIllustration = '/images/content.png';

const services = [
  {
    icon: 'images/tv.svg',
    title: 'Content Delivery',
    description:
      '',
    items: [
      'Our robust Premium SMS Service can be used to provide news alerts, quotes, content like games, videos to users.',

    ]
  },
  {
    icon: 'images/receipt.svg',
    title: 'Content Billing',
    description: '',
    items: [
      'We help you set up Custom subscription &  billing plan tailored to your business model',
    ]
  },
  {
    icon: 'images/pie.svg',
    title: 'Analytics & Insights',
    description: '',
    items: ['We provide Performance dashboards and usage reports so you can track your revenue']
  }
];

const industries = [
  {
    label: 'Retail & E-commerce',
    desc: 'Send flash sale alerts, order confirmations, or delivery updates.',
  },
  { label: 'Banking & Finance',
    desc: 'OTP, balance alerts, loan reminders, and fraud warnings—safe and fast.'
   },
  { label: 'Healthcare',
    desc:'Appointment reminders, follow-up messages, or health tips.'
   },
  { label: 'Education',
    desc:'Send exam updates, fee reminders, or emergency alerts to parents/students.'
   },
  { label: 'Events & Entertainment',
    desc:'Boost attendance with invites, RSVP links, and last-minute updates.'
   },
  { label: 'Logistics & Transport',
    desc:'Real-time tracking alerts, dispatch updates, and driver communications.'
   },
  { label: 'Saccos & Cooperatives',
    desc:'Notify members on meetings, dividends, or loan status quickly.'
   },
  { label: 'NGOs & Religious Groups',
    desc:'Mobilize, inform, and update communities in seconds.'
   },
];

const useCases = [
  { title: 'Promo Campaigns', text: 'Announce offers, discounts & new arrivals.' },
  { title: 'Reminders & Alerts', text: 'Avoid no-shows. Send timely nudges.' },
  { title: 'Two-Factor Authentication', text: 'Quick & secure OTPs for safe logins.' },
  { title: 'Customer Support', text: 'Confirm tickets, update statuses, follow up.' },
  { title: 'Internal Team Updates', text: 'Need to reach all the staff fast? Done!' },
  { title: 'Feedback & Surveys', text: 'Get customer opinions in real time.' },
];

export default function BulkSMSPage() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <main className="bulk-sms-page">
      {/* Hero */}
      <section className="hero-section">
        <h1>SMS</h1>
        <p className="subtitle">Connect with your customers like never before with our all-in-one SMS platform — supporting both Bulk and Premium SMS solutions.</p>
      </section>

      {/* Why */}
      <section className="why-section">
        <h2>Why Bulk SMS?</h2>
        <div className="why-container">
          <div className="why-image">
            <img
              src="/images/bulksms.svg"
              alt="Person texting"
            />
          </div>
          <div className="why-text">
            <h3>Engage Customers Instantly</h3>
            <p style={{marginBottom:"10px"}}>Do you need to run a campaign or send updates? Our Bulk SMS solution is fast, affordable, and easy to use.</p>

            <ul>
              <li>Choose between a no-code solution – simple to use web interface or API solution to cover every use case.</li>

            </ul>
            <a
                        href="https://app.peakmobile.co.ke/signin" 
                        target="_blank"
                        rel="noopener noreferrer">
            <button className="btn-primary-sms">Get Started →</button>

            </a>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section-sms">
        <h2>Key Platform Features</h2>
        <div className="features-grid-sms">
          {features.map((f, i) => (
            <div key={i} className="feature-card-sms">
              <p className="feature-title-sms">{f.title}</p>
              {f.subtitle && <p className="feature-sub">{f.subtitle}</p>}
            </div>
          ))}
        </div>
      </section>

      {/* Industries */}
      <section className="industries-section">
        <h2>Industries Use Cases</h2>
        <div className="industries-container">
          <ul className="industry-list">
            {industries.map((item, i) => (
              <li
                key={i}
                className={`industry-item ${openIdx === i ? 'open' : ''}`}
                onClick={() => setOpenIdx(i)}
              >
                <span className="label">{item.label}</span>
                <span className="arrow">→</span>
                {openIdx === i && item.desc && (
                  <p className="desc">{item.desc}</p>
                )}
              </li>
            ))}
          </ul>
          <div className="industry-image">
            <img
              src="/images/industries.jpg"
              alt="Woman on laptop"
            />
          </div>
        </div>
      </section>

      {/* Use Cases */}
      <section className="usecases-section-sms">
      <h2>Smart Ways to Use Bulk SMS</h2>
      <p className="small-sms">160 Characters of Pure Magic</p>
      <div className="usecases-grid-sms">
        {useCases.map((u, i) => (
          <div key={i} className="usecase-card-sms">
            <h4>{u.title}</h4>
            <p>{u.text}</p>
          </div>
        ))}
      </div>
    </section>
    <section className="hero-section">
        <h1>Premium SMS</h1>
        <p>
        Deliver and monetize digital content via Premium short codes- available on demand or through subscriptions.
        </p>
      </section>

      {/* Billing Intro */}
      <section className="billing-section">
        <div className="billing-container">
          <div className="billing-image">
            <img src={billingIllustration} alt="Content billing illustration" />
          </div>
          <div className="billing-text">
            <h2>Seamless digital content monetization through carrier billing.</h2>
            <p>
              At Peak Mobile, we make it effortless for customers to purchase digital content
              using their mobile carrier bill. Our advanced technology platforms and deep telco
              integration expertise enable content providers to enhance monetization, extend
              market reach, and drive sustainable growth.
            </p>
            <button className="btn-primary">Book a Demo →</button>
          </div>
        </div>
      </section>

      {/* Core Services */}
      <section className="core-services">
        <h2>Features</h2>
        <div className="services-grid">
          {services.map((svc, i) => (
            <div key={i} className="service-card">
              <img src={svc.icon} alt={`${svc.title} icon`} className="service-icon" />
              <h3>{svc.title}</h3>
              {svc.description && <p className="service-desc">{svc.description}</p>}
              {svc.items && (
                <ul className="service-list">
                  {svc.items.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </section>





    </main>
  );
}
